import { TxnData } from '~/components/txn-display/state-change/types'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'
import { MetadataPayloads } from '~/types'
import { parseTransactionMetadata } from '~/utils/parseTransactionMetadata'

export const getCustomCallData = ({
  transaction,
  txnData,
}: {
  transaction?: OrgRegularTransaction | PublicRegularTransaction
  txnData?: TxnData
}) => {
  const transactionMetadata = parseTransactionMetadata(
    transaction?.transactionMetadata as MetadataPayloads[],
  )
  const storedCustomCallData = transactionMetadata.customCallData
  const customCallData =
    txnData?.customCallData ??
    (storedCustomCallData
      ? {
          contractAddress: storedCustomCallData.calls?.[0]?.to,
          functionSignature: storedCustomCallData.calls?.[0]?.functionSignature,
          contractName: storedCustomCallData.calls?.[0]?.contractName,
        }
      : undefined)

  return customCallData
}
